import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { useState } from "react";
import { updateSector } from "../../../redux/actions";
import SuccessModal from "../../../components/modals/successModal";
import ErrorModal from "../../../components/modals/errorModal";
import Button from "../../../components/button";

function CambiarSectorComponent({ onClose, refreshDetalle }) {
  const dispatch = useDispatch();
  let { id } = useParams();

  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [errorModal, setErrorModal] = useState({
    show: false,
    message: "",
  });
  const [loading, setLoading] = useState(false);

  const openErrorModal = (message) =>
    setErrorModal({ show: true, message });

  const closeErrorModal = () =>
    setErrorModal({ show: false, message: "" });

  const {
    register,
    handleSubmit,
  } = useForm();

  const onSubmit = async (data, event) => {
    event.preventDefault();

    setLoading(true);

    const finalData = { ...data, id: id };

    try {
      const response = await dispatch(updateSector(finalData));

      if (response) {
        setShowSuccessModal(true);
      }
    } catch (error) {
      console.error(error);

      const serverErrorMessage =
        error.response?.data?.error ||
        "Error inesperado al actualizar el sector.";

      openErrorModal(serverErrorMessage);
    } finally {
      setLoading(false);
    }
  };

  const handleCloseSuccess = () => {
    setShowSuccessModal(false);

    if (typeof refreshDetalle === "function") {
      refreshDetalle();
    }

    onClose();
  };

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/50"
      onClick={onClose}
    >
      {showSuccessModal && (
        <SuccessModal
          closeSuccessModal={handleCloseSuccess}
          message="Sector actualizado con éxito."
        />
      )}

      {errorModal.show && (
        <ErrorModal
          closeErrorModal={closeErrorModal}
          message={errorModal.message}
        />
      )}

      <div className="relative">
        <button
          type="button"
          onClick={onClose}
          className="absolute top-3 right-3 text-gray-400 hover:text-gray-600"
        >
          ✕
        </button>

        <form
          onSubmit={handleSubmit(onSubmit)}
          onClick={(e) => e.stopPropagation()}
        >
          <div className="w-[20rem] bg-white p-6 rounded-lg shadow-lg">
            <div className="text-2xl font-bold mb-4 text-center">
              Cambiar Sector
            </div>

            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Sector
              </label>

              <select
                className="w-full p-2 border rounded"
                {...register("sector", {
                  required: "Ingrese un sector por favor",
                })}
              >
                {Array.from({ length: 26 }, (_, i) => {
                  const letter = String.fromCharCode(65 + i);

                  return (
                    <option key={letter} value={letter}>
                      {letter}
                    </option>
                  );
                })}
              </select>
            </div>

            <div className="flex flex-col justify-center gap-4">
              <Button type="submit" fullWidth loading={loading}>
                Guardar
              </Button>

              <Button
                type="button"
                variant="secondary"
                fullWidth
                disabled={loading}
                onClick={onClose}
              >
                Cancelar
              </Button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}

export default CambiarSectorComponent;